import { IExame } from './iexame';

export interface IExameState {
    exame: IExame,
    exames: IExame[],
    error?: any,
    categoria: string
}
